<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">查詢條件內容</h3>
                </div>
                <div v-if="isLoading" class="modal-body">
                    <Message
                        class="my-5 d-flex justify-content-center"
                        loading
                        message="資料讀取中，請稍候..."
                    />
                </div>
                <div v-else class="modal-body">
                    <form class="form">
                        <div class="row">
                            <!-- 特殊條件編號 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-8 text-left"
                                        for="mid-code">特殊條件編號：{{ code }}</label>
                                </div>
                            </div>
                            <!-- 特殊條件名稱 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-8 text-left"
                                        for="mid-name">特殊條件名稱：{{ codename }}</label>
                                </div>
                            </div>
                            <!-- 條件內容 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-left" for="small-detail">條件內容：</label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <table class="table datatable">
                        <thead>
                            <tr>
                                <th style="width:18%" class="text-center px-0">條件項目</th>
                                <th style="width:12%" class="text-center">運算子</th>
                                <th style="width:70%" class="text-center">規則</th>
                            </tr>
                        </thead>
                        <tbody v-if="detaillist.length">
                            <tr v-for="(detail, i) in detaillist" :key="`detail-${i}`">
                                <td class="text-center p-0">{{ detail.detailname }}</td>
                                <td class="text-center px-0">{{ detail.operatorname }}</td>
                                <td class="text-center px-0">
                                    <template v-if="detail.detailkey === 'PRODUCTID'">
                                        <div v-for="(product,i) in detail.contentlist" :key="i">{{ product }}</div>
                                    </template>
                                    <template v-else>
                                        {{ detail.content }}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <a @click="doConfirm()" class="btn btn-primary">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import { getSpecialConditionDetail } from "@/service";

export default {
    name: "SpecialConditionDetailModal",
    components: { Message },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        code: {
            type: String, 
            required: true, 
            default: ""
        },
        codename: {
            type: String, 
            required: true, 
            default: ""
        }
    },
    data() {
        return {
            isLoading: true,
            detaillist: [],
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.isLoading = true;
                this.getDetail();
            }
        },
    },
    methods: {
        async getDetail() {
            await getSpecialConditionDetail(
                this.$store.state.userInfo.id,
                this.code
            ).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.detaillist = result.data;
                } else {
                    this.detaillist = [];
                }
                this.isLoading = false;
            });
        },
        doConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>

<style scoped>
.modal.fade .modal-body {
    min-height: auto;
}
</style>